import { generateActions } from '../utils'
import { API_CONST } from '../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  success: false,
  error: null
}

const heroRequestActions = generateActions('heroRequests/SUBMIT')

export const submitHeroRequest = createAction(API_CONST, (data = {}) => ({
  method: 'post',
  noRedirect: true,
  actions: heroRequestActions,
  url: 'hero-requests/form',
  params: { ...data },
}))

export default handleActions({
  [heroRequestActions[0]]: state => ({
    ...state,
    error: null,
    success: false
  }),
  [heroRequestActions[1]]: (state, { payload }) => ({
    ...state,
    success: true,
    error: null
  }),
  [heroRequestActions[2]]: (state, { payload }) => ({
    ...state,
    success: false,
    error: payload
  }),
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/heroRequests.js